import { ReactNode } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& > svg': {
      width: '1rem',
      height: '1rem',
    },
  },
});

export interface ListItemIconProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className' | 'children'> {
  children: ReactNode;
  className?: string;
}

export const ListItemIcon = ({
  children,
  className,
  ...rest
}: ListItemIconProps) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)} {...rest}>
      {children}
    </div>
  );
};

ListItemIcon.displayName = 'ListItem.Icon';
